import { useNavigate, useParams } from 'react-router-dom';
import {
    CheckCircleIcon,
    ClockIcon,
    ExclamationCircleIcon,
    ChevronRightIcon,
} from '@heroicons/react/24/outline';

const getStatusCfg = (status, isFrench) => ({
    submitted: { label: isFrench ? 'Soumis' : 'Submitted', icon: ClockIcon, cls: 'text-amber-600 bg-amber-50' },
    reviewed:  { label: isFrench ? 'Révisé' : 'Reviewed', icon: CheckCircleIcon, cls: 'text-emerald-600 bg-emerald-50' },
    'not started': { label: isFrench ? 'À remplir' : 'Not started', icon: ExclamationCircleIcon, cls: 'text-red-500 bg-red-50' },
}[status] || { label: status, icon: ExclamationCircleIcon, cls: 'text-slate-500 bg-slate-100' });

function fieldLabel(name, isFrench) {
    if (name && typeof name === "object") {
        return isFrench ? (name.fr || name.en) : (name.en || name.fr);
    }
    return name;
}

export default function FormCard({ form, language }) {
    const navigate = useNavigate();
    const { id } = useParams();
    const isFrench = language === 'french';

    const statusCfg = getStatusCfg(form.status, isFrench);
    const StatusIcon = statusCfg.icon;
    const isNotStarted = form.status === 'not started';

    return (
        <div className={`group bg-white rounded-[2rem] transition-all duration-300 ${
            isNotStarted ? 'shadow-xl shadow-slate-200/50' : 'opacity-80'
        }`}>
            <div className="p-8 md:p-10 flex flex-col md:flex-row gap-8 items-center">
                <div className="flex-1 space-y-3 min-w-0">
                    <div className="flex items-center gap-3 flex-wrap">
                        <h3 className="text-xl font-bold text-slate-900">{fieldLabel(form.name, isFrench)}</h3>
                        <span className={`flex items-center gap-1 text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${statusCfg.cls}`}>
                            <StatusIcon className="h-3 w-3" />
                            {statusCfg.label}
                        </span>
                    </div>
                    <p className="text-slate-500 text-sm leading-relaxed max-w-xl">
                        {isFrench
                            ? 'Formulaire en ligne à remplir directement.'
                            : 'Online form to complete directly.'}
                    </p>
                </div>

                <div className="w-full md:w-64 flex flex-col justify-center shrink-0">
                    <button
                        onClick={() => navigate(`/upload/${id}/form/${form._id}`)}
                        className={`flex items-center justify-center gap-2 py-4 px-6 rounded-2xl text-xs font-bold transition-all ${
                            isNotStarted
                                ? 'bg-indigo-600 hover:bg-indigo-700 text-white shadow-lg shadow-indigo-200/60 active:scale-[0.98]'
                                : 'text-slate-400 hover:text-sky-600 hover:bg-sky-50'
                        }`}
                    >
                        {isNotStarted
                            ? (isFrench ? 'Remplir le formulaire' : 'Fill Out Form')
                            : (isFrench ? 'Voir ma soumission' : 'View Submission')}
                        <ChevronRightIcon className="h-4 w-4" />
                    </button>
                </div>
            </div>
        </div>
    );
}
